/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ progress: NonNullable<unknown>, fps: NonNullable<unknown> }} Video_Export_Progress_LabelInputs */

const en_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exporting - ${i?.progress}% | ${i?.fps}FPS`)
};

const fr_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportation - ${i?.progress}% | ${i?.fps}FPS`)
};

const de_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportieren - ${i?.progress}% | ${i?.fps}FPS`)
};

const it_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione - ${i?.progress}% | ${i?.fps}FPS`)
};

const ru_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт - ${i?.progress}% | ${i?.fps}FPS`)
};

const es_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando - ${i?.progress}% | ${i?.fps}FPS`)
};

const zh_cn2_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出 - ${i?.progress}% | ${i?.fps}FPS`)
};

const ja_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エクスポート中 - ${i?.progress}% | ${i?.fps}FPS`)
};

const hi_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`निर्यात हो रहा है - ${i?.progress}% | ${i?.fps}FPS`)
};

const pt_pt2_video_export_progress_label = /** @type {(inputs: Video_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando - ${i?.progress}% | ${i?.fps}FPS`)
};

/**
* | output |
* | --- |
* | "Exporting - {progress}% \| {fps}FPS" |
*
* @param {Video_Export_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_progress_label = /** @type {((inputs: Video_Export_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_progress_label(inputs)
	if (locale === "de") return de_video_export_progress_label(inputs)
	if (locale === "it") return it_video_export_progress_label(inputs)
	if (locale === "ru") return ru_video_export_progress_label(inputs)
	if (locale === "es") return es_video_export_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_progress_label(inputs)
	if (locale === "ja") return ja_video_export_progress_label(inputs)
	if (locale === "hi") return hi_video_export_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_progress_label(inputs)
	return en_video_export_progress_label(inputs)
});